import React from 'react'
import styled from '@emotion/styled'
import { blueBase } from '../../constants/principles'

export default () => {
  return <StyledDiv>After you edit the Offer, the consumer automatically gets an email with the new Offer amount and the changes you've made.</StyledDiv>
}

const StyledDiv = styled.div`
  color: ${blueBase};
  background-color: #e7f5fe;
  border: 1.5px solid #3c7ec6;
  border-radius: 4px;
  font-weight: 700;
  margin-top: 8px;
  margin-bottom: 32px;
  padding: 16px 24px;
  text-align: center;
`
